export interface Mission {
  name: string;
  actions: MissionAction[];
  geoFence?: GeoFence;
}

export enum MissionActionType {
  TakeOff = 'TakeOff',
  GoToWaypoint = 'GoToWaypoint',
  Orbit = 'Orbit',
  ReturnToBase = 'ReturnToBase',
  Land = 'Land'
}

// Base interface for mission actions
export interface MissionAction {
  type: MissionActionType;
}

// Take off from the given location up to the given altitude
export interface TakeOffAction extends MissionAction {
  location: [number, number]; // longitude, latitude
  altitude: number; // meters
  verticalSpeed: number; // meters/sec
}

// Go to the given location and altitude
export interface GoToWaypointAction extends MissionAction {
  location: [number, number]; // longitude, latitude
  altitude: number; // meters
  speed: number; // 3-D speed, km/h
}

export interface OrbitAction extends MissionAction {
  center: [number, number]; // longitude, latitude
  radius: number; // meters
  altitude: number; // meters
  speed: number; // km/h
}

// Return to take off location and altitude
export interface ReturnToBaseAction extends MissionAction {}

// Land at the current location
export interface LandAction extends MissionAction {
  verticalSpeed: number; // meters/sec
}

export interface GeoFenceBase {
  name: string;
}

export interface GeoFenceCircle extends GeoFenceBase {
  type: 'circle';
  center: [number, number]; // longitude, latitude,
  radius: number; // in meters
}

export interface GeoFencePolygon extends GeoFenceBase {
  type: 'polygon';
  polygon: [number, number][]; // longitude, latitude
}

export type GeoFence = GeoFenceCircle | GeoFencePolygon;
